import { render, staticRenderFns } from "./BookingCancelModal.vue?vue&type=template&id=b24dc692&"
import script from "./BookingCancelModal.vue?vue&type=script&lang=js&"
export * from "./BookingCancelModal.vue?vue&type=script&lang=js&"
import style0 from "./BookingCancelModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports